window.google_api_key = 'AIzaSyDMPrHLTmq7dMlCsXic0x0BTswGOXnn7q8'
window.google_client_id = '115817287370-ittn312dodvrq56cpbohb5opa9dvat2q.apps.googleusercontent.com'
window.google_scopes = ['https://www.googleapis.com/auth/drive']
